import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
// Side-effect registration only — the locale file registers itself without
// switching the global locale, so other dayjs consumers are unaffected.
import 'dayjs/locale/pt-br.js';
dayjs.extend(customParseFormat);
// Day-first (Brazilian) dates with /, - or . separators, plus ISO and written
// pt-BR forms. Strict mode makes dayjs validate the calendar (month lengths,
// leap years) by re-formatting the parsed value and comparing it to the input —
// which is also why every written form needs both D and DD variants ("5" vs "05").
const ACCEPTED_DATE_FORMATS = [
    'DD/MM/YYYY',
    'D/M/YYYY',
    'DD-MM-YYYY',
    'D-M-YYYY',
    'DD.MM.YYYY',
    'D.M.YYYY',
    'YYYY-MM-DD',
    'DD [de] MMMM [de] YYYY',
    'D [de] MMMM [de] YYYY',
    'DD [de] MMM [de] YYYY',
    'D [de] MMM [de] YYYY',
    'DD MMMM YYYY',
    'D MMMM YYYY',
    'DD MMM YYYY',
    'D MMM YYYY',
];
// Prefix (not full-string) match: Yggy official values can be full ISO timestamps.
const ISO_DATE_PREFIX_PATTERN = /^\d{4}-\d{2}-\d{2}/;
const parseCalendarDate = (value) => {
    const trimmed = value.trim();
    const dateText = ISO_DATE_PREFIX_PATTERN.test(trimmed) ? trimmed.slice(0, 10) : trimmed;
    // Month names match via case-sensitive lookup against the locale's lowercase
    // arrays, so lowercase first. Strip ordinal markers after digits ("1º"),
    // periods after letters ("mar." — digit separators like 15.03.1990 are
    // untouched), and collapse whitespace. Numeric inputs pass through unchanged.
    const normalized = dateText
        .toLowerCase()
        .replace(/(\d)\s*[º°]/g, '$1')
        .replace(/(\p{L})\./gu, '$1')
        .replace(/\s+/g, ' ');
    const parsed = dayjs(normalized, ACCEPTED_DATE_FORMATS, 'pt-br', true);
    return parsed.isValid() ? parsed : null;
};
export const parseDateToIsoDateString = (value) => parseCalendarDate(value)?.format('YYYY-MM-DD') ?? null;
// UTC noon, not midnight: birth dates land in Postgres DATE columns and
// node-postgres serializes Date params in process-local time — a UTC-midnight
// Date shifts to the previous calendar day on any UTC-negative server.
export const parseDateToUtcNoonDate = (value) => {
    const parsed = parseCalendarDate(value);
    if (!parsed)
        return null;
    return new Date(Date.UTC(parsed.year(), parsed.month(), parsed.date(), 12));
};
//# sourceMappingURL=parse-date.js.map